import {of as observableOf,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { CustomerService } from 'app/services/customer.service';
import { InvoiceModel } from 'app/models/invoices.model';

@Injectable()
export class CustomerInvoicesResolver implements Resolve<Array<InvoiceModel>> {

    constructor(private service: CustomerService, private router: Router) 
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<Array<InvoiceModel>> {
        return this.service.GetCustomerInvoices(route.parent.params.id);
    }
}